const { h, render, Component } = require('preact');
const {route} = require('preact-router');

const OtherIssuesView = require('../../views/main/other_issues')
const Web2018Helper = require('../../../helper')
const BreadCrumbsHelper = require('../../views/common/breadcrumbs/helper')

class OtherIssues extends Component {
  constructor(props) {
    super(props);
    this.handleUnableToSignIn = this.handleUnableToSignIn.bind(this)
    this.handleReportSuspiciousActivity = this.handleReportSuspiciousActivity.bind(this)
    this.handleFacebookOrderHelp = this.handleFacebookOrderHelp.bind(this);
    this.listOfKeysForContactChannelsComponent = ['dropdownCategory', 'dropdownSubcategory', 'title', 'primaryCategoryId', 'title', 'contentId']
  }

  invokeContactChannels(contactReason){
    let selectedInbentaResult = this.listOfKeysForContactChannelsComponent.reduce(function(object, key){
      object[key] = contactReason;
      return object;
    }, {});

    let qs = Web2018Helper.getQueryStringForFAQToContactChannels(selectedInbentaResult)
    route(`/customer_support/web/contact_channels?${ qs }`);
  }

  handleUnableToSignIn(){
    let landingPageFAQs = Groupon.Utils.getConfigFromDom().landingPageFAQs;
    if (landingPageFAQs[3]) {
      route(`/faq#faqs:category-${landingPageFAQs[3].categoryId}?crumbs=${BreadCrumbsHelper.articleCrumbQSWithoutFAQs()}`)
    }
    else {
      this.invokeContactChannels(I18n.translate("js.modules.web_2018.unable_to_sign_in"))
    }
  }

  handleReportSuspiciousActivity(){
    this.invokeContactChannels(I18n.translate("js.modules.web_2018.report_suspicious_activity"))
  }

  handleFacebookOrderHelp() {
    route(`/faq#faqs:${Groupon.Utils.getConfigFromDom().fbOrderContactLandingFAQId}?crumbs=${BreadCrumbsHelper.articleCrumbQSWithoutFAQs()}`);
  }

  render() {
    return (
      <OtherIssuesView
        handleUnableToSignIn = {this.handleUnableToSignIn}
        handleReportSuspiciousActivity = {this.handleReportSuspiciousActivity}
        handleFacebookOrderHelp = {this.handleFacebookOrderHelp}
      />
    );
  }
}
module.exports = OtherIssues
